import { render, staticRenderFns } from "./content.vue?vue&type=template&id=74ae5230&scoped=true&"
import script from "./content.vue?vue&type=script&lang=ts&"
export * from "./content.vue?vue&type=script&lang=ts&"
import style0 from "./content.vue?vue&type=style&index=0&lang=less&"
import style1 from "./content.vue?vue&type=style&index=1&id=74ae5230&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ae5230",
  null
  
)

export default component.exports